import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import { useUser } from '../../contexts/UserContext';
import showToast from '../../utils/toastHelper';

const VoterOrganizations = () => {
  const [organizations, setOrganizations] = useState([]);
  const [filteredOrganizations, setFilteredOrganizations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/organizations/available-for-voting`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const orgs = response.data.data || [];
      setOrganizations(orgs);
      setFilteredOrganizations(orgs);
    } catch (error) {
      console.error('Failed to fetch organizations:', error);
      showToast('Failed to load organizations', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredOrganizations(organizations);
      return;
    }
    const filtered = organizations.filter(org => 
      org.name.toLowerCase().includes(query.toLowerCase()) ||
      org.description?.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredOrganizations(filtered);
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="mb-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <div>
            <h3 style={{ fontWeight: '600' }}>Organizations</h3>
            <p className="mb-0" style={{ fontSize: '0.875rem', color: '#6b7280' }}>
              Browse and participate in elections
            </p>
          </div>
          {organizations.length > 0 && (
            <div className="position-relative w-100" style={{ maxWidth: '350px' }}>
              <i className="bi bi-search position-absolute" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280', zIndex: 10 }}></i>
              <input
                type="text"
                className="form-control"
                placeholder="Search organizations..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                style={{
                  paddingLeft: '2.5rem',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px'
                }}
              />
            </div>
          )}
        </div>
      </div>

      {organizations.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <i className="bi bi-building" style={{ fontSize: '3rem', color: '#d1d5db' }}></i>
            <p className="mt-3 text-muted">No organizations with active elections available at the moment.</p>
          </div>
        </div>
      ) : filteredOrganizations.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <i className="bi bi-search" style={{ fontSize: '3rem', color: '#d1d5db' }}></i>
            <p className="mt-3 text-muted">No organizations found matching "{searchQuery}"</p>
            <button onClick={() => handleSearch('')} className="btn btn-sm btn-outline-primary mt-2">
              Clear search
            </button>
          </div>
        </div>
      ) : (
        <div className="row">
          {filteredOrganizations.map((org) => (
            <div key={org.id} className="col-12 col-md-6 col-lg-4 mb-4">
              <Link to={`/voter/organizations/${org.id}/elections`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="card h-100" style={{ transition: 'transform 0.2s', cursor: 'pointer' }}
                     onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                     onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <div style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '12px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'white',
                          fontSize: '1.25rem',
                          fontWeight: '600',
                          marginRight: '0.75rem',
                          flexShrink: 0
                        }}>
                          {org.name?.charAt(0) || 'O'}
                        </div>
                        <div className="flex-grow-1" style={{ minWidth: 0 }}>
                          <h5 className="mb-1" style={{ fontWeight: '600', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{org.name}</h5>
                          {org.isUserOrganization && (
                            <span className="badge" style={{ 
                              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              fontSize: '0.7rem' 
                            }}>
                              Your Organization
                            </span>
                          )}
                        </div>
                      </div>
                  
                      {org.description && (
                        <p className="mb-3" style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                          {org.description.length > 120 
                            ? `${org.description.substring(0, 120)}...` 
                            : org.description}
                        </p>
                      )}
                  
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mt-3 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                    <div className="d-flex flex-wrap gap-3">
                      {(org.activeElectionsCount > 0) && (
                        <div className="text-muted" style={{ fontSize: '0.813rem' }}>
                          <i className="bi bi-check-circle me-1" style={{ color: '#10b981' }}></i>
                          {org.activeElectionsCount} Active
                        </div>
                      )}
                      {(org.upcomingElectionsCount > 0) && (
                        <div className="text-muted" style={{ fontSize: '0.813rem' }}>
                          <i className="bi bi-clock me-1" style={{ color: '#f59e0b' }}></i>
                          {org.upcomingElectionsCount} Upcoming
                        </div>
                      )}
                    </div>
                    <span
                      className="btn btn-sm"
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          color: 'white',
                          border: 'none',
                          padding: '0.375rem 1rem',
                          fontSize: '0.813rem',
                          fontWeight: '500',
                          cursor: 'pointer',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        View Elections
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VoterOrganizations;
